import linkToAdminPages from "../links";

export default function linkToReadingsDownload() {
  return `${linkToAdminPages()}/readings`;
}
